import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { LoanSummaryCard } from "../../../components";
import { calculateTotalNoOfInstallments, usCurrency } from "../../../utils";
import PaymentDetails from "./PaymentDetails/PaymentDetails";
import Documents from "./Documents/Documents";
import RequestSummary from "./RequestSummary/RequestSummary";
import LoanDisclaimer from "./LoanDisclaimer";

const LoanModifySummary = ({
  keyValue,
  paymentMethod,
  tabChange,
  fieldValues,
  loanData,
  planData,
  loanSettingInfo,
  filteredValues,
  today,
  loanStatus,
  sourceSplit,
  sourceSplitData,
  principalPaid,
  isModified,
  setModifyFor,
  setSliderOpen2,
  calculateTotalFees,
  calculateNetAmount,
  fromApproval,
}) => {
  return (
    <div className="loan-summary-container">
      <LoanDisclaimer
        loanData={loanData}
        loanStatus={loanStatus}
        isModified={isModified}
        setModifyFor={setModifyFor}
        setSliderOpen2={setSliderOpen2}
      />
      <LoanSummaryCard
        loanData={loanData}
        planData={planData}
        loanSettingInfo={loanSettingInfo}
        employeeInfo={filteredValues}
        principalPaid={principalPaid}
        calculateTotalNoOfInstallments={calculateTotalNoOfInstallments}
      />
      <Tabs
        activeKey={keyValue}
        transition={false}
        onSelect={tabChange}
        mountOnEnter
        unmountOnExit
      >
        <Tab eventKey={1} title={"Request Summary"}>
          <RequestSummary
            principalPaid={principalPaid}
            currentData={loanData}
            updatedData={loanData?.reAmortizationRequestDetails}
            sourceSplit={sourceSplit}
            sourceSplitData={sourceSplitData}
            loanStatus={loanStatus}
            calculateNetAmount={calculateNetAmount}
            fromApproval={fromApproval}
          />
        </Tab>
        <Tab eventKey={2} title={"Payment Details"}>
          <PaymentDetails
            paymentMethod={paymentMethod}
            fieldValues={fieldValues}
            loanData={loanData}
            loanSettingInfo={loanSettingInfo}
            today={today}
            calculateNetAmount={calculateNetAmount}
            calculateTotalFees={calculateTotalFees}
          />
        </Tab>
        <Tab eventKey={3} title={"Documents"}>
          <Documents loanData={loanData} />
        </Tab>
        {/* <Tab eventKey={4} title={"History"}>
          History
        </Tab> */}
      </Tabs>
    </div>
  );
};

export default LoanModifySummary;
